// extracted by mini-css-extract-plugin
export default {"switcherButton":"k-5OG","active":"xnECY","tooltip":"XCUI-"};